import { render, staticRenderFns } from "./abandoned-cart-handler.vue?vue&type=template&id=14839278&lang=pug"
import script from "./abandoned-cart-handler.vue?vue&type=script&lang=js"
export * from "./abandoned-cart-handler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports